const DASHBOARD_ROUTE_NAMES = ['Dashboard', 'DefaultDashboard'];
const RESTORE_POLL_MS = 250;
const RESTORE_MAX_ATTEMPTS = 12;
const USER_SCROLL_EVENTS = ['wheel', 'touchmove', 'keydown', 'pointerdown'];

let pending = null;
let cancelPendingRestore = () => {};

export const getDashboardScrollContainer = () =>
    document.querySelector('.sub-route-layout__leading') || document.querySelector('.pendo-page-container');

// Muuri lays out in web workers, so the page only reaches full height some time after mount.
// Only user input stops the wait; a scrollTop change may just be the browser clamping it while the grid is short.
// Returns a function that stops waiting.
export function restoreScrollWhenReachable (top, { intervalMs, maxAttempts }) {
    let attempts = 0;
    let poll = null;
    const stop = () => {
        clearInterval(poll);
        USER_SCROLL_EVENTS.forEach((type) => window.removeEventListener(type, stop, true));
    };
    USER_SCROLL_EVENTS.forEach((type) => window.addEventListener(type, stop, { capture: true, passive: true }));
    poll = setInterval(() => {
        attempts += 1;
        const container = getDashboardScrollContainer();
        // 1px slack: scrollTop can be fractional under display scaling while scrollHeight is rounded.
        const isTallEnough = container && container.scrollHeight - container.clientHeight >= top - 1;
        if (isTallEnough) {
            container.scrollTo({ top, behavior: 'instant' });
        }
        if (isTallEnough || attempts >= maxAttempts) {
            stop();
        }
    }, intervalMs);

    return stop;
}

// Called when a widget link leaves a dashboard; only a Back to that dashboard restores the position.
export function rememberDashboardScroll (route) {
    pending = { fullPath: route.fullPath, top: getDashboardScrollContainer()?.scrollTop };
}

export function restoreDashboardScroll (to, savedPosition) {
    cancelPendingRestore();
    if (!DASHBOARD_ROUTE_NAMES.includes(to.name)) return;
    const { fullPath, top } = pending || {};
    pending = null;
    if (!savedPosition || !top || fullPath !== to.fullPath || to.query.widgetId) return;
    // The scroll container persists across routes, so start from the top until the saved position is reachable.
    getDashboardScrollContainer()?.scrollTo({ top: 0, behavior: 'instant' });
    cancelPendingRestore = restoreScrollWhenReachable(top, {
        intervalMs: RESTORE_POLL_MS,
        maxAttempts: RESTORE_MAX_ATTEMPTS,
    });
}
